export default function updateHeaderItems() {
  let isMobile;

  function triggerFeature() {
    const matches = globalThis.matchMedia('(max-width: 1170px)').matches;

    if (matches === isMobile) return;

    isMobile = matches;

    if (matches) {
      // mobile items
      $('.header #siteInfoBannerWidget').appendTo('.headerInnerContent');
    } else {
      // desktop items
      $('.header #siteInfoBannerWidget').insertAfter('.top-bar .inner-container .logo-container');
    }
  }

  triggerFeature();

  $(globalThis).on('resize', triggerFeature);
}
